var _jsxFileName = "/src/main/react/src/main/app/components/navigation/Footer.js";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { ExpansionPanel, Grid } from '@material-ui/core';
import { HomeButton, UploadButton } from '../common';
import { LOCAL_STORAGE_ITEM_NAMES, TPIS_CAPABILITIES as CAPS } from "../domain/constants";
import Util from '../../util/Util';
import { stringToList } from "../../util/StringUtil";
const styles = () => ({});
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adiId: props.adiId != null ? props.adiId : null,
      merlinId: props.merlinId != null ? props.merlinId : null,
      title: props.title != null ? props.title : null
    };
  }
  render() {
    const caps = stringToList(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.capabilities));
    return /*#__PURE__*/React.createElement(ExpansionPanel, {
      defaultExpanded: true,
      elevation: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      alignContent: "center",
      justify: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(HomeButton, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 25
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 21
      }
    }, Util.isVisibleForCapabilities(caps, [CAPS.WRITE]) && /*#__PURE__*/React.createElement(UploadButton, {
      adiId: this.state.adiId,
      merlinId: this.state.merlinId,
      title: this.state.title,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 25
      }
    }))));
  }
}
export default withStyles(styles)(withRouter(Footer));